import { cn } from '@crabs-ai/ds-react';
import TtsVoiceCard from '@/shared/components/dialog/TtsDialog/TtsVoiceCard';
import React from 'react';
import { useTtsDialog } from './TtsDialogContext';
import { VideoEditorTTSVoice } from '@/shared/apis/tts/get-tts-voices';

interface TtsVoiceListProps {
  voices: VideoEditorTTSVoice[];
  onVoiceClick?: (voice: VideoEditorTTSVoice) => void;
  emptyText?: string;
}

export default function TtsVoiceList({
  voices,
  onVoiceClick,
  emptyText,
}: TtsVoiceListProps) {
  // Context에서 상태 가져오기
  const { selectedVoice, setSelectedVoice, setSelectedEmotion } =
    useTtsDialog();

  if (voices.length === 0 && emptyText) {
    return (
      <div className="flex min-h-7xl items-center justify-center rounded-xs border border-dashed border-sys-style-neutral-light bg-sys-bg-surface px-sm py-md text-center text-body-small text-sys-cont-neutral-light">
        {emptyText}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(290px,1fr))] gap-2xs">
      {voices.map((voice) => (
        <div
          key={voice.code}
          className={cn(
            'rounded-xs border border-sys-style-neutral-light transition-all',
            selectedVoice?.code === voice.code &&
              'border-sys-style-primary-default',
          )}
        >
          <TtsVoiceCard
            voice={voice}
            onClick={() => {
              if (onVoiceClick) {
                onVoiceClick(voice);
              } else {
                setSelectedVoice(voice);
                setSelectedEmotion(voice.emotions[0] ?? null);
              }
            }}
          />
        </div>
      ))}
    </div>
  );
}
